import React from 'react';
import {
  IonBreadcrumb,
  IonBreadcrumbs,
  IonButton,
  IonContent,
  IonRow
} from '@ionic/react';
import SearchBar from 'components/searchbar/SearchBar';
import LoadingIonList from 'core/layout/loading-ion-list/LoadingIonList';
import DocumentsGridView from 'features/shared/documents/components/DocumentsGridView';
import DocumentsListView from 'features/shared/documents/components/DocumentsListView';
import ViewModeToggle from 'features/shared/documents/components/ViewModeToggle';
import { Document } from 'core/types';
import { ViewMode } from 'features/shared/documents/DocumentsSlice';
import { getCleanLabel } from 'core/util';

interface DesktopDocumentsViewProps {
  type: string;
  search: string;
  onSearchChange: (value: string) => void;
  documents: Document[];
  filteredDocuments: Document[];
  loading: boolean;
  viewMode: ViewMode;
  documentTypeLabel: string;
  onAddDocument: (type: string) => void;
  onDocumentClick: (document: Document) => void;
}

const DesktopDocumentsView: React.FC<DesktopDocumentsViewProps> = ({
  type,
  search,
  onSearchChange,
  documents,
  filteredDocuments,
  loading,
  viewMode,
  documentTypeLabel,
  onAddDocument,
  onDocumentClick
}) => {
  return (
    <>
      <IonRow className="hk-desktop-digital-documents-list-header">
        <div className="hk-desktop-digital-documents-list-header-container">
          <IonBreadcrumbs className="hk-desktop-digital-documents-list-header-breadcrumbs">
            <IonBreadcrumb href="/documents">Documents</IonBreadcrumb>
            {type && type.startsWith('construction') ? (
              <>
                <IonBreadcrumb href="/documents/group/construction">
                  Construction
                </IonBreadcrumb>
                <IonBreadcrumb>
                  {getCleanLabel(documentTypeLabel)}
                </IonBreadcrumb>
              </>
            ) : (
              <IonBreadcrumb>{getCleanLabel(documentTypeLabel)}</IonBreadcrumb>
            )}
          </IonBreadcrumbs>
          <div className="hk-desktop-digital-documents-list-header-right">
            <div className="hk-desktop-digital-documents-list-search">
              <SearchBar
                value={search}
                disabled={documents?.length === 0}
                onSearchChange={onSearchChange}
              />
            </div>
            <div className="hk-desktop-digital-documents-list-header-button">
              <IonButton
                expand="block"
                color="primary"
                strong={true}
                onClick={() => onAddDocument(type)}
              >
                Upload Document
              </IonButton>
            </div>
          </div>
        </div>
      </IonRow>

      <IonContent>
        <ViewModeToggle
          currentViewMode={viewMode}
          itemCount={filteredDocuments.length}
        />

        <LoadingIonList
          loading={loading}
          items={filteredDocuments}
          className={`hk-desktop-digital-document-list ${type}`}
          label={documentTypeLabel}
        >
          {viewMode === ViewMode.LIST ? (
            <DocumentsListView
              documents={filteredDocuments}
              onDocumentClick={onDocumentClick}
            />
          ) : (
            <DocumentsGridView
              documents={filteredDocuments}
              onDocumentClick={onDocumentClick}
            />
          )}
        </LoadingIonList>
      </IonContent>
    </>
  );
};

export default DesktopDocumentsView;
